/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WizardFilterOptionDto
 */
export interface WizardFilterOptionDto {
    /**
     * 
     * @type {string}
     * @memberof WizardFilterOptionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WizardFilterOptionDto
     */
    name: string;
}

/**
 * Check if a given object implements the WizardFilterOptionDto interface.
 */
export function instanceOfWizardFilterOptionDto(value: object): value is WizardFilterOptionDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function WizardFilterOptionDtoFromJSON(json: any): WizardFilterOptionDto {
    return WizardFilterOptionDtoFromJSONTyped(json, false);
}

export function WizardFilterOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WizardFilterOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function WizardFilterOptionDtoToJSON(json: any): WizardFilterOptionDto {
    return WizardFilterOptionDtoToJSONTyped(json, false);
}

export function WizardFilterOptionDtoToJSONTyped(value?: WizardFilterOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

